import SessionContext from '@/context/SessionContext';
import { useContext, useDebugValue } from 'react';

const useSession = () => {
  const context = useContext(SessionContext);
  const { session } = context;
  useDebugValue(session, (session) =>
    session?.email ? 'Logged In' : 'Logged Out'
  );
  return context;
};

export default useSession;
